import { render, staticRenderFns } from "./OrganismQrAccessDashboard.vue?vue&type=template&id=020bc63e&scoped=true&"
import script from "./OrganismQrAccessDashboard.vue?vue&type=script&lang=js&"
export * from "./OrganismQrAccessDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OrganismQrAccessDashboard.vue?vue&type=style&index=0&id=020bc63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020bc63e",
  null
  
)

export default component.exports